'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VisibilityIcon = require('./components/VisibilityIcon.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_VisibilityIcon).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/visibility-icon/index.js
// module id = 1058
// module chunks = 0